import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../components/storefront/Header';
import Footer from '../components/storefront/Footer';
import FloatingButtons from '../components/storefront/FloatingButtons';

function Layout() {
    const { i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';

    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            minHeight: '100vh',
            direction: isRTL ? 'rtl' : 'ltr'
        }}>
            <Header />
            <Box component="main" sx={{ flexGrow: 1 }}>
                <Outlet />
            </Box>
            <Footer />
            <FloatingButtons />
        </Box>
    );
}

export default Layout;
